var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('h2',[_vm._v("Todos os episódios:")]),_c('ul',_vm._l((_vm.episodes),function(episode){return _c('li',{key:episode.title},[_c('episode-card',{attrs:{"episode":episode}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }